var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner tracking-detail",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            !_vm.optStatus.edit
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.showSop },
                      on: { click: _vm.showAdd }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.CreateStatusDetail"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isNew,
                          expression: "!isNew"
                        }
                      ],
                      attrs: { type: "primary", disabled: _vm.showSop },
                      on: { click: _vm.showEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isNew,
                          expression: "!isNew"
                        }
                      ],
                      attrs: { type: "danger", disabled: _vm.showSop },
                      on: { click: _vm.toDel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.save } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isNew,
                          expression: "!isNew"
                        }
                      ],
                      attrs: { type: "danger" },
                      on: { click: _vm.toDel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                  )
                ],
            _c(
              "el-button",
              {
                attrs: {
                  disabled: _vm.optStatus.edit || _vm.optStatus.sopEdit,
                  type: "danger"
                },
                on: { click: _vm.toConfigSop }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.ConfigureSOPMessagePush"))
                )
              ]
            )
          ],
          2
        )
      ]),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { height: "calc( 100% - 45px)" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", staticStyle: { height: "50%" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          !_vm.isNew
                            ? _vm.$t("SystemMaintenance.EditStatusDetail")
                            : _vm.$t("SystemMaintenance.CreateStatusDetail")
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "trackingDetailForm",
                      staticStyle: { width: "100%" },
                      attrs: { "label-position": "left", "label-width": "90px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.SerialNumber")
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              "controls-position": "right",
                              disabled: !_vm.optStatus.edit
                            },
                            model: {
                              value: _vm.trackingDetailForm.level,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingDetailForm, "level", $$v)
                              },
                              expression: "trackingDetailForm.level"
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.defaultNode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "defaultNode",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.defaultNode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.InitialStatus")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SystemMaintenance.Code") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.optStatus.edit },
                            model: {
                              value: _vm.trackingDetailForm.code,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingDetailForm, "code", $$v)
                              },
                              expression: "trackingDetailForm.code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ChineseName3")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.optStatus.edit },
                            model: {
                              value: _vm.trackingDetailForm.codeCname,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "codeCname",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.codeCname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.EnglishName3")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.optStatus.edit },
                            model: {
                              value: _vm.trackingDetailForm.codeEname,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "codeEname",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.codeEname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.StatusType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.stateType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "stateType",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.stateType"
                              }
                            },
                            _vm._l(_vm.stateTypes, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.trackingDetailForm, "type", $$v)
                                },
                                expression: "trackingDetailForm.type"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.AutomaticTrigger")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TriggerType") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              disabled:
                                !_vm.optStatus.edit ||
                                !_vm.trackingDetailForm.type,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_EntityTriggerType,
                              cache: false,
                              headers: [
                                "CODE",
                                _vm.$t("SystemMaintenance.EnglishName3")
                              ],
                              fields: ["fieldCode", "fieldEname"],
                              "callback-params": { key: "event" },
                              "callback-method-type": "obj",
                              "default-value": _vm.trackingDetailForm.event,
                              "static-options": _vm.triggerTypeList,
                              "tag-value": "uuid",
                              "tag-name": "fieldName",
                              "filter-tag-names": ["fieldCode", "fieldEname"]
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.currentTriggerObj.fieldCode ===
                                "_itrace_code",
                              expression:
                                "currentTriggerObj.fieldCode==='_itrace_code'"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ExternalCode")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              url: _vm.url.sys.trackingDetailExternal,
                              headers: [
                                "CODE",
                                _vm.$t("SystemMaintenance.Name")
                              ],
                              fields: ["code", "serviceName"],
                              "callback-params": { key: "externalCode" },
                              disabled: !_vm.optStatus.edit,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.trackingDetailForm.externalCode,
                              "static-options": _vm.sopExternalCodeConfigList,
                              "tag-value": "code",
                              "tag-name": "serviceName",
                              "filter-tag-names": ["code", "serviceName"]
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      ),
                      _vm.currentTriggerObj.fieldEname === "生成电子文件"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.FileType")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "205px" },
                                attrs: {
                                  filterable: "",
                                  url: _vm.url.sys.docTypeByLob,
                                  headers: [
                                    "CODE",
                                    _vm.$t("SystemMaintenance.ChineseName3")
                                  ],
                                  fields: ["code", "name"],
                                  "method-params": { lob: _vm.currentLob },
                                  "callback-params": {
                                    key: "documentTypeUuid"
                                  },
                                  disabled: !_vm.optStatus.edit,
                                  "callback-method-type": "obj",
                                  "static-options": _vm.documentTypeList,
                                  "default-value":
                                    _vm.trackingDetailForm.documentTypeUuid,
                                  "tag-value": "uuid",
                                  "tag-name": "name",
                                  "filter-tag-names": ["code", "name"]
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.DataService")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              clearable: "",
                              disabled: !_vm.optStatus.edit,
                              "static-options": _vm.dataServices,
                              "default-value":
                                _vm.trackingDetailForm.dataService,
                              "tag-value": "code",
                              "filter-tag-names": ["englishName", "chineseName"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.trackingDetailForm.dataService = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.PublicOrNot")
                          }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { disabled: !_vm.optStatus.edit },
                            model: {
                              value: _vm.trackingDetailForm.published,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.trackingDetailForm,
                                  "published",
                                  $$v
                                )
                              },
                              expression: "trackingDetailForm.published"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.ReportTemplate")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              headers: [
                                _vm.$t("SystemMaintenance.ChineseName3")
                              ],
                              fields: ["name"],
                              "callback-params": { key: "templateUuid" },
                              disabled: !_vm.optStatus.edit,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.trackingDetailForm.templateUuid,
                              "static-options": _vm.templateList,
                              "tag-value": "uuid",
                              "tag-name": "name",
                              "filter-tag-names": ["name"]
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SystemMaintenance.Remark") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              disabled: !_vm.optStatus.edit
                            },
                            model: {
                              value: _vm.trackingDetailForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingDetailForm, "remark", $$v)
                              },
                              expression: "trackingDetailForm.remark"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("FinanceManage.charge_sp7") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "80%",
                              "padding-right": "10px"
                            },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.txtCharge,
                              callback: function($$v) {
                                _vm.txtCharge = $$v
                              },
                              expression: "txtCharge"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.optStatus.edit
                              },
                              on: { click: _vm.selectHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("tracking-detail-sop-warning-config", {
                ref: "trackWarningConfig",
                attrs: {
                  "opt-status-edit": _vm.optStatus.edit,
                  "tracking-detail": _vm.trackingDetailForm
                }
              }),
              _c(
                "el-card",
                {
                  ref: "trackNoteByInside",
                  class: ["box-card", _vm.optStatus.edit ? "" : "not-click"],
                  staticStyle: { height: "30%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { padding: "2px 0" },
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.StatusChangeNotification")
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { "label-position": "left", "label-width": "0px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.sendInnerNotify,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm,
                                    "sendInnerNotify",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.sendInnerNotify"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.SendNotification")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.DoNotSendNotification"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.post,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "post",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.post"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.DesignatedPost")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.sales,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "sales",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.sales"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sales")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.op,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "op",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.op"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Operation"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.csr,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "csr",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.csr"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.CustomerService")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.overseaOp,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "overseaOp",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.overseaOp"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.OverseasCustomerService"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.dc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "dc",
                                    $$v
                                  )
                                },
                                expression: "trackingDetailForm.innerConfig.dc"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Document"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.planner,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "planner",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.planner"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.LineManager"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.siteOp,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "siteOp",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.siteOp"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.FieldOperation")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId1",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId1"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig
                                    .userDefinedRoleId2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "userDefinedRoleId2",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.userDefinedRoleId2"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              on: {
                                change: function($event) {
                                  _vm.trackingDetailForm.innerConfig.userList = []
                                }
                              },
                              model: {
                                value:
                                  _vm.trackingDetailForm.innerConfig.personnel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "personnel",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.personnel"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.DesignatedPersonnel"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              fields: ["chineseName"],
                              disabled:
                                !_vm.optStatus.edit ||
                                !_vm.trackingDetailForm.innerConfig.personnel,
                              "callback-params": { key: "userList" },
                              "callback-method-type": "value",
                              "tag-value": "userId",
                              "tag-name": "chineseName",
                              "filter-tag-names": ["chineseName"],
                              "method-params": {
                                pageSize: 1000000,
                                active: true,
                                hasRole: true
                              },
                              "default-multiple-value":
                                _vm.trackingDetailForm.innerConfig.userList,
                              multiple: "",
                              filterable: "",
                              "options-width": "230px"
                            },
                            on: {
                              parentCallBack: _vm.getInnerConfigValueFromChild
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: !_vm.optStatus.edit },
                              model: {
                                value: _vm.trackingDetailForm.innerConfig.email,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingDetailForm.innerConfig,
                                    "email",
                                    $$v
                                  )
                                },
                                expression:
                                  "trackingDetailForm.innerConfig.email"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Email")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("tracking-detail-notify-ext-panel", {
                ref: "trackNotifyExt",
                attrs: {
                  "opt-status-edit": _vm.optStatus.edit,
                  "is-new": _vm.isNew,
                  "tracking-detail": _vm.trackingDetailForm
                }
              })
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSop,
                  expression: "showSop"
                }
              ],
              staticClass: "box-card",
              staticStyle: { "flex-grow": "1" }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("SystemMaintenance.SopPushLog")))
                ])
              ]),
              _c("div", { staticClass: "app-main-inner-row" }, [
                _c(
                  "div",
                  [
                    _vm.optStatus.sopCellEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveSopCellEdit }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Confirm")))]
                        )
                      : _vm._e(),
                    _vm.optStatus.sopCellEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.cancelSopCellEdit }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                        )
                      : _vm._e(),
                    !_vm.optStatus.sopCellEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.showEditSop }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                        )
                      : _vm._e(),
                    !_vm.optStatus.sopCellEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: { click: _vm.delSop }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", height: "200px" },
                    attrs: {
                      "show-side-bar": false,
                      "column-defs": _vm.sopGrid.columnDefs,
                      "row-data": _vm.sopGrid.rowData,
                      "grid-options": _vm.sopGrid.gridOptions
                    },
                    on: { gridReady: _vm.onSopReady }
                  })
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "trackingDetailForm",
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "left", "label-width": "90px" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.PushTarget") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { disabled: !_vm.optStatus.sopEdit },
                          model: {
                            value: _vm.sopForm.pushObject,
                            callback: function($$v) {
                              _vm.$set(_vm.sopForm, "pushObject", $$v)
                            },
                            expression: "sopForm.pushObject"
                          }
                        },
                        _vm._l(_vm.pushObjects, function(item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { label: item.chineseName, value: item.name }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.PushChannel") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { disabled: !_vm.optStatus.sopEdit },
                          model: {
                            value: _vm.sopForm.pushChannel,
                            callback: function($$v) {
                              _vm.$set(_vm.sopForm, "pushChannel", $$v)
                            },
                            expression: "sopForm.pushChannel"
                          }
                        },
                        _vm._l(_vm.pushChannels, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _c("el-checkbox", {
                        staticStyle: { "padding-left": "10px" },
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_SendToEachRecipientSeparately"
                          )
                        },
                        model: {
                          value: _vm.sopForm.sendAlone,
                          callback: function($$v) {
                            _vm.$set(_vm.sopForm, "sendAlone", $$v)
                          },
                          expression: "sopForm.sendAlone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.sopForm.pushChannel === 0
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.SubjectTemplate")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.optStatus.sopEdit },
                              on: {
                                focus: function($event) {
                                  _vm.eFocus = _vm.constant.eFocus.emailTitle
                                }
                              },
                              model: {
                                value: _vm.sopForm.templateTitle2Email,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateTitle2Email",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateTitle2Email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { height: "180px" },
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TextTemplate")
                            }
                          },
                          [
                            _c("quill-editor", {
                              ref: "emailTextQuillEditor",
                              staticStyle: { height: "130px" },
                              attrs: {
                                disabled: !_vm.optStatus.sopEdit,
                                options: _vm.editorOption
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.onEditorFocus($event)
                                }
                              },
                              model: {
                                value: _vm.sopForm.templateText2Email,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateText2Email",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateText2Email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            class: { "not-click": !_vm.optStatus.sopEdit },
                            attrs: {
                              label: _vm.$t("SystemMaintenance.DataItem")
                            }
                          },
                          _vm._l(_vm.sopDataItems, function(item, index) {
                            return _c(
                              "el-button",
                              {
                                key: index,
                                staticStyle: {
                                  "margin-left": "0px",
                                  "margin-right": "10px"
                                },
                                attrs: { type: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.onClickSopDataItem(index)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "SystemMaintenance.AttachmentFileType"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.optStatus.sopEdit,
                                  expression: "!optStatus.sopEdit"
                                }
                              ],
                              staticStyle: { width: "300px" },
                              attrs: { disabled: true },
                              model: {
                                value: _vm.currFileTypeNames,
                                callback: function($$v) {
                                  _vm.currFileTypeNames = $$v
                                },
                                expression: "currFileTypeNames"
                              }
                            }),
                            _c(
                              "el-dropdown",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.optStatus.sopEdit,
                                    expression: "optStatus.sopEdit"
                                  }
                                ],
                                attrs: {
                                  trigger: "click",
                                  placement: "bottom-start"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "Message.PleaseEnterTheFileType"
                                        )
                                      },
                                      model: {
                                        value: _vm.currFileTypeNames,
                                        callback: function($$v) {
                                          _vm.currFileTypeNames = $$v
                                        },
                                        expression: "currFileTypeNames"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    staticClass: "app-main-inner-row row-grid",
                                    staticStyle: {
                                      width: "350px",
                                      height: "200px"
                                    },
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c("cargo-ag-grid", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%"
                                      },
                                      attrs: {
                                        "show-side-bar": false,
                                        "grid-options":
                                          _vm.fileTreeGrid.gridOptions,
                                        "column-defs":
                                          _vm.fileTreeGrid.columnDefs,
                                        "row-data": _vm.fileTreeGrid.rowData
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm.sopForm.pushChannel === 1
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateSubject")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "300px" },
                                attrs: { disabled: !_vm.optStatus.sopEdit },
                                model: {
                                  value: _vm.sopForm.templateTheme,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sopForm, "templateTheme", $$v)
                                  },
                                  expression: "sopForm.templateTheme"
                                }
                              },
                              _vm._l(_vm.templateThemes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.chineseName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateContent")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                type: "textarea",
                                rows: 5
                              },
                              on: {
                                focus: function($event) {
                                  _vm.eFocus = _vm.constant.eFocus.noteContent
                                }
                              },
                              model: {
                                value: _vm.sopForm.templateTitle2Note,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateTitle2Note",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateTitle2Note"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SystemMaintenance.TemplateExample")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 5,
                                disabled: ""
                              },
                              model: {
                                value: _vm.sopForm.templateText2Note,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.sopForm,
                                    "templateText2Note",
                                    $$v
                                  )
                                },
                                expression: "sopForm.templateText2Note"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "center" }
                },
                [
                  !_vm.optStatus.sopCellEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveSop }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Confirm")))]
                      )
                    : _vm._e(),
                  !_vm.optStatus.sopCellEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.cancelSop }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showSendSopTest }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SendTest")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.sendSopTest.visible,
            title: _vm.$t("SystemMaintenance.SendTest"),
            width: "400px",
            "close-on-click-modal": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sendSopTest, "visible", $event)
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SendTo")))]),
          _c("el-input", {
            staticStyle: { width: "200px" },
            model: {
              value: _vm.sendSopTest.target,
              callback: function($$v) {
                _vm.$set(_vm.sendSopTest, "target", $$v)
              },
              expression: "sendSopTest.target"
            }
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sendSopTestHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.sendSopTestCloseHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("tracking-charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "selected-list": _vm.chargePlanDialog.selectList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: function(schemeDetails) {
            _vm.selectedSchemeHandler(schemeDetails)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }